module.exports = __webpack_public_path__ + "img/f84cce6e52b440b0896c38edba9041c0.ed41dfd4.jpg";